// Module
var code = "<div class=\"dtp-ui-grid\" cg-busy=\"$ctrl.serverOperation\"> <div id=\"fileSkuGrid\" ag-grid=\"$ctrl.fileMarketSkusGridOptions\" class=\"ag-theme-balham\" style=\"min-height:200px\"></div> </div> ";
// Exports
module.exports = code;